import React, { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import styled from 'styled-components';
import { COLORS } from '../../app/common/constants/styles';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import { TextHelpers } from '../../utils/textHelpers';
import { useSelector } from 'react-redux';
import { POLICY_JAPAN_TITLE_ID } from './CancelMembership';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    border: 0;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
    max-width: 1068px;
    font-weight: 400;
    font-size: 0.875rem;
    h1 {
        font-size: 1.1875em;
    }
    h2 {
        font-size: 0.875rem;
    }
    ul,
    ol {
        margin: 20px;
        font-size: 0.875rem;
        line-height: 1.5;
        padding: 0;
    }
    a {
        color: ${COLORS.blue};
        cursor: pointer;
        text-decoration: underline;
        &:hover {
            font-weight: bold;
        }
    }
`;

const CancelMembershipMarkDown: React.FC<{ policyTitleId: string }> = ({ policyTitleId }) => {
    const [markdown, setMarkdown] = useState('');
    const currentLanguage = useSelector((state: IReduxRootState) => state.app.locale);

    const policyUrl =
        policyTitleId === POLICY_JAPAN_TITLE_ID
            ? TextHelpers.replaceLang(
                  `${process.env.PUBLIC_URL}/static/policies/cancel_policy_jpn_{lang}.md`,
                  currentLanguage,
              )
            : `${process.env.PUBLIC_URL}/static/policies/oversea.md`;

    useEffect(() => {
        fetch(policyUrl)
            .then((response) => response.text())
            .then((text) => setMarkdown(text));
    }, []);

    return (
        <Wrapper>
            <Markdown
                children={markdown}
                components={{
                    em: ({ node, ...props }) => <span style={{ color: '#bf0000' }} {...props} />,
                    a: ({ node, ...props }) => <a style={{ color: '#006A9E' }} {...props} />,
                }}
            />
        </Wrapper>
    );
};

export default CancelMembershipMarkDown;
